export default __webpack_public_path__ + "static/media/icons-metaverses-unreal-engine.f246dc9b.svg";